<template>
    <link-button-block v-if="isLinkButtonBlock" v-bind="$props"/>
    <toggle-allergens-button-block v-else-if="showToggle" :clickToogle="toggleFeatures" v-bind="$props"/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Block from './Block.vue';

import { buttonBlockType } from '../constants';
import { MultiLanguageText, TextProps } from '../models';

export default {
  name: 'button-block',
  components: {
    LinkButtonBlock: () => import('./buttonBlocks/LinkButtonBlock.vue'),
    ToggleAllergensButtonBlock: () => import('./buttonBlocks/ToggleAllergensButtonBlock.vue')
  },
  extends: Block,
  props: {
    behaviourType: { type: String, default: buttonBlockType.DEFAULT },
    buttonProps: { type: Object, default: () => ({}) }
  },
  computed: {
    ...mapGetters(['showFeatures']),
    isLinkButtonBlock() {
      return this.behaviourType === buttonBlockType.LINK;
    },
    isShowAllergensButtonBlock() {
      return this.behaviourType === buttonBlockType.SHOW_ALLERGENS;
    },
    isHideAllergensButtonBlock() {
      return this.behaviourType === buttonBlockType.HIDE_ALLERGENS;
    },
    myTextProps() {
      return new TextProps(this.myButtonProps.textProps);
    },
    myButtonText() {
      return new MultiLanguageText(this.myButtonProps.text);
    },
    toggleFeatures() {
      if (this.isShowAllergensButtonBlock) {
        return this.showAllergens;
      }
      if (this.isHideAllergensButtonBlock) {
        return this.hideAllergens;
      }
      return {};
    },
    showToggle() {
      if (!this.showFeatures && this.isShowAllergensButtonBlock) {
        return true;
      }
      if (this.showFeatures && this.isHideAllergensButtonBlock) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(['setShowFeatures']),
    showAllergens() {
      this.setShowFeatures(true);
    },
    hideAllergens() {
      this.setShowFeatures(false);
    }
  }
};
</script>
